// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app-dark":"App_app-dark__jmJ1X","app-light":"App_app-light__1nOog","app-scrollable":"App_app-scrollable__9Ca7t"};